import { gql } from "@apollo/client";

export const PRODUCT_AVAILABILITY_FRAGMENT = gql`
  fragment AvailabilityFragment on ProductAvailability {
    date
    status
    timeSlots {
      time
      status
      groups {
        id
        seatsAvailable
        isEmpty
        isPrivate
        guides {
          id
          nickName
          profilePic
          introVideo
          reviewSummary {
            average
            numReviews
          }
        }
      }
    }
  }
`;
